import { Suspense, lazy } from "react";
import { SearchActionDialogsProps } from "./SearchActionDialogs.types";

const SearchExportModal = lazy(() =>
  import("./SearchExportModal").then((m) => ({ default: m.SearchExportModal }))
);
const MarketingListChangeModal = lazy(() =>
  import("./MarketingListChangeModal").then((m) => ({ default: m.MarketingListChangeModal }))
);
const BulkEditModal = lazy(() =>
  import("./BulkEditModal").then((m) => ({ default: m.BulkEditModal }))
);
const SearchStatusModal = lazy(() =>
  import("./SearchStatusModal").then((m) => ({ default: m.SearchStatusModal }))
);

/** The dialog for the chosen action on the selected records. Held outside the menu, so closing it does not. */
export function SearchActionDialogs({ search, active, onClose }: SearchActionDialogsProps) {
  const changed = () => search.refresh();

  return (
    <Suspense fallback={null}>
      {active === "export" && <SearchExportModal search={search} onClose={onClose} />}
      {active === "addToList" && (
        <MarketingListChangeModal search={search} remove={false} onClose={onClose} />
      )}
      {active === "removeFromList" && (
        <MarketingListChangeModal search={search} remove onClose={onClose} />
      )}
      {active === "bulkEdit" && (
        <BulkEditModal search={search} onClose={onClose} onChanged={changed} />
      )}
      {(active === "activate" || active === "deactivate") && (
        <SearchStatusModal
          search={search}
          activate={active === "activate"}
          onClose={onClose}
          onChanged={changed}
        />
      )}
    </Suspense>
  );
}
